import React from 'react';
import { Star } from 'lucide-react';
export function StatsBar() {
  return <div className="bg-lightgray border-y border-border py-8" data-id="element-187">
      <div className="max-w-6xl mx-auto px-4" data-id="element-188">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-border" data-id="element-189">
          <div className="flex flex-col items-center justify-center" data-id="element-190">
            <span className="text-2xl md:text-4xl font-heading font-bold text-navy mb-1" data-id="element-191">
              +1,000
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-192">
              Families Already Have It
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-193">
            <span className="text-2xl md:text-4xl font-heading font-bold text-navy mb-1" data-id="element-194">
              6
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-195">
              Tomes Included
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-196">
            <span className="text-2xl md:text-4xl font-heading font-bold text-navy mb-1" data-id="element-197">
              5
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-198">
              Bonuses Included
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-199">
            <div className="flex items-center justify-center mb-1" data-id="element-200">
              <span className="text-2xl md:text-4xl font-heading font-bold text-navy mr-2" data-id="element-201">
                4.9/5
              </span>
              <div className="flex" data-id="element-202">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 text-gold fill-gold" data-id="element-203" />)}
              </div>
            </div>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-204">
              Rating
            </span>
          </div>
        </div>
      </div>
    </div>;
}